module.exports = __webpack_public_path__ + "static/media/imgll2.be37a41e.jpg";